import { ApiError } from "./client";

// A file fetched whole, as a blob: the library's export, or a share card's
// image. A response that isn't ok throws, as the client's calls do.
export const fetchBlob = async (
  url: string,
  options?: { credentials: RequestCredentials },
): Promise<Blob> => {
  const response = await fetch(url, options);
  if (!response.ok) throw new ApiError(response.status, null);
  return response.blob();
};
